import ConnectWithUs from '../ConnectWithUs';
import { useContext } from 'react';
import JsxParser from 'react-jsx-parser';

import Disclaimer from 'components/Disclaimer';
import FooterList from 'components/FooterList';
import Icon from 'components/Icon';
import InverseLogo from 'components/InverseLogo';

import phoneContext from 'contexts/phone';
import purlAgentContext from 'contexts/purlAgentContext';
import zipcodeContext from 'contexts/zipCode';

import formatPhoneNumber from 'utilities/formatPhoneNumber';
import scrollToTop from 'utilities/scrollToTop';

import envelopeImg from './images/envelope.svg';
import phoneImg from './images/phone.svg';

import {
    companyLinks,
    companyLinks1,
    disclaimerText,
    disclaimerText2,
    disclaimerText3,
    learningCenterLinks
} from './constants';

import styles from './styles.module.scss';

const Footer = ({ className = '', shouldHideLinks = false }) => {
    const { phone } = useContext(phoneContext);

    const { purlAgentData } = useContext(purlAgentContext);
    const zipCodeContextMap = useContext(zipcodeContext);

    const { email, virtualNumber } = purlAgentData || {};

    const { text = '' } = phone;

    const questionsLinks = [
        {
            link: '/',
            text: `Call ${text} to speak with a licensed insurance agent`
        }
    ];

    const agentContactDetails = purlAgentData && [
        {
            link: `mailto:${email}`,
            externalURL: true,
            text: (
                <>
                    <Icon
                        className={`${styles.envelopeIcon}`}
                        image={envelopeImg}
                    />{' '}
                    {email}
                </>
            )
        },
        {
            link: `tel:${virtualNumber}`,
            externalURL: true,
            text: (
                <>
                    <Icon className={`${styles.phoneIcon}`} image={phoneImg} />{' '}
                    {formatPhoneNumber(virtualNumber?.substring(2))}
                </>
            )
        }
    ];

    return (
        <footer
            className={`${styles.footer} ${className} ${
                shouldHideLinks ? styles.footerNoLinks : ''
            }`}
            data-gtm="footer"
            id="plan-footer"
        >
            <InverseLogo
                className={styles.logo}
                linkClassName={styles.logoLinkClassName}
            />

            {!shouldHideLinks && (
                <FooterList
                    className={styles.learningCenter}
                    items={learningCenterLinks}
                    onClick={scrollToTop}
                    title="Introduction to Medicare"
                />
            )}

            {!shouldHideLinks && (
                <FooterList
                    className={styles.company}
                    items={purlAgentData ? companyLinks1 : companyLinks}
                    onClick={scrollToTop}
                    title="Company"
                />
            )}

            {!shouldHideLinks && (
                <FooterList
                    className={styles.questions}
                    items={purlAgentData ? agentContactDetails : questionsLinks}
                    onClick={scrollToTop}
                    title="Questions?"
                />
            )}
            <ConnectWithUs className={styles.connectWithUs} />

            <Disclaimer className={styles.disclaimer}>
                <JsxParser
                    bindings={{
                        disclaimerLink: styles.disclaimerLink
                    }}
                    jsx={`
                  <p class="${styles.disclaimerText}">${disclaimerText}</p>
                  <p class="${styles.disclaimerText}">${disclaimerText2.replace(
                        /\$\{([^}]+)\}/g,
                        (_, group) => {
                            return zipCodeContextMap[group.trim()];
                        }
                    )}</p>
                  <p class="${styles.disclaimerText}">${disclaimerText3}</p>
                  `}
                />
            </Disclaimer>
        </footer>
    );
};

export default Footer;
